import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { ISignupSetPasscode, ISignupSetPasscodeResponse } from '../models/signup-set-passcode.model';
import { fromSignupSetPasscodeActions } from '../actions/index';

export const signupSetPasscodeFeatureKey = 'signupSetPasscode';

export interface SignupSetPasscodeState {
  signupSetPasscodeRequest: ISignupSetPasscode;
  signupSetPasscodeSuccess: ISignupSetPasscodeResponse;
  signupSetPasscodeFailure: IGenericError<ErrorResponse>;
}

export const initialState: SignupSetPasscodeState = {
  signupSetPasscodeRequest: undefined,
  signupSetPasscodeFailure: undefined,
  signupSetPasscodeSuccess: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromSignupSetPasscodeActions.loadSignupSetPasscodes, (state, action) => ({
    ...state,
    signupSetPasscodeRequest: action.request,
    isLoading: true
  })),
  on(fromSignupSetPasscodeActions.loadSignupSetPasscodesSuccess, (state, action) => ({
    ...state,
    signupSetPasscodeSuccess: action.response,
    isLoading: false
  })),
  on(fromSignupSetPasscodeActions.loadSignupSetPasscodesFailure, (state, action) => ({
    ...state,
    signupSetPasscodeFailure: action.error,
    isLoading: false
  }))
);

export const getSignupSetPasscodeRequest = (state: SignupSetPasscodeState) => state.signupSetPasscodeRequest;
export const getSignupSetPasscodeSuccess = (state: SignupSetPasscodeState) => state.signupSetPasscodeSuccess;
export const getSignupSetPasscodeFailure = (state: SignupSetPasscodeState) => state.signupSetPasscodeFailure;
